import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import axios from 'axios';
import mapObjIndexed from 'ramda/src/mapObjIndexed';
import pathOr from 'ramda/src/pathOr';
import { getGeo, requestGeo } from './utils/geo';
import { getUserAgent } from './utils/userAgent';
import { getDeviceId, stages } from './utils';
import { appVersion } from './config/version';
export var cancelSource;
var headers = {
  'Content-Type': 'application/json',
  'x-application-version': appVersion
};
var instance = axios.create({
  headers: headers,
  baseURL: stages()
});
var instanceSocial = axios.create({
  headers: headers,
  baseURL: stages().replace('auth', 'api/service')
});
instance.defaults.transformRequest = [function addDeviceId(data) {
  if (data) {
    var type = pathOr(false, ['profile', 'type'], data);

    if (type === 'TEMPORARY_WEB') {
      data.profile.device = getDeviceId();
    } else {
      data.device = getDeviceId();
    }

    return data;
  }

  return {};
}].concat(_toConsumableArray(instance.defaults.transformRequest));

var requestInterceptor = function requestInterceptor(config) {
  var fcmToken = localStorage.getItem('fcm_token');
  cancelSource = axios.CancelToken.source();
  config.cancelToken = cancelSource.token;

  if (fcmToken) {
    config.headers['x-pushid'] = fcmToken;
  }

  var geo = getGeo();
  var userAgent = getUserAgent();

  if (userAgent) {
    config.headers['X-User-Agent'] = userAgent;
  }

  if (geo) {
    config.headers['X-Geo'] = geo;
  } else {
    requestGeo();
  }

  return config;
};

instance.interceptors.request.use(requestInterceptor);
export var setLanguage = function setLanguage(lang) {
  instance.defaults.headers['X-Language'] = lang;
};
export var setStage = function setStage(stage) {
  instance.defaults.baseURL = stages(stage);
  instanceSocial.defaults.baseURL = stages(stage).replace('auth', 'api/service');
};
export var setCast = function setCast(cast) {
  instance.defaults.headers['x-cast'] = cast;
};
export var setHeaders = function setHeaders(headers) {
  mapObjIndexed(function (value, key) {
    instance.defaults.headers[key] = value;
  }, headers);
};
export var Auth = {
  sign: function sign(data) {
    return instance.post('/cast', data);
  },
  login: function login(data) {
    return instance.post('/auth/api/profiles/tickets', data);
  },
  socialLogin: function socialLogin(data) {
    return instance.post('/auth/api/profiles/social-tickets', data);
  },
  sendRecoveryTicket: function sendRecoveryTicket(data) {
    return instance.post('/auth/api/profiles/credentials', data);
  },
  checkRecoveryTicket: function checkRecoveryTicket(data) {
    return instance.put('/auth/api/profiles/tickets/check', data);
  },
  updateCredentialsByRecoveryTicket: function updateCredentialsByRecoveryTicket(data) {
    return instance.put('/auth/api/profiles/credentials', data);
  },
  createProfile: function createProfile(data) {
    return instance.post('/profiles/api/profiles', data);
  },
  profile: function profile(resourceid, headers) {
    return instance.get("/profiles/api/profiles/".concat(resourceid), {
      headers: headers
    });
  },
  loyalty: function loyalty(resourceid, headers) {
    return instance.get("/loyalty/api/loyalties/".concat(resourceid), {
      headers: headers
    });
  },
  linkSocialAccount: function linkSocialAccount(resourceid, headers, data) {
    return instance.put("/profiles/api/profiles/".concat(resourceid, "/social-accounts"), data, {
      headers: headers
    });
  },
  sendConfirmationCode: function sendConfirmationCode(data) {
    return instance.put('/auth/api/profiles/tickets/confirmation', data);
  },
  resendConfirmationCode: function resendConfirmationCode(data) {
    return instance.put('/auth/api/profiles/tickets/resend-code', data);
  }
};
export var Campaigns = {
  getCampaignsByProfileId: function getCampaignsByProfileId(profileId, headers) {
    return instance.get("/segmentator/api/campaigns/participants/".concat(profileId), {
      headers: headers
    });
  }
};
export var getAllowedSocials = function getAllowedSocials() {
  return instanceSocial.get('/social');
};